import { styled } from '@mui/material';

import Button from '../../components/Button';
import { checkboxClasses } from '../../components/FormControls/Checkbox';
import RadioOption, { radioOptionClasses } from '../../components/FormControls/RadioGroup/RadioOption';
import Checkbox from '../../components/HookFormControls/Checkbox';

export const TileDrawerButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(2.25, 4.75),
  minHeight: 'unset',
}));

export const TileDrawerCheckbox = styled(Checkbox)(({ theme }) => ({
  marginLeft: theme.spacing(-2),
  [`& .${checkboxClasses.icon}, & .${checkboxClasses.checkedIcon}`]: {
    fontSize: '1rem',
  },
  [`& .${checkboxClasses.label}`]: {
    ...theme.typography.paragraphRegular,
    color: theme.palette.common.black,
  },
})) as typeof Checkbox;

export const WidgetWrapperRadioOption = styled(RadioOption)(() => ({
  margin: 0,
  [`& .${radioOptionClasses.radioRoot}`]: {
    display: 'none',
  },
}));
